module.exports = __webpack_public_path__ + "static/media/img_1-6_dlflcinsig.0755cd89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_1-6_dlflcinsig.svg
// module id = 678
// module chunks = 0